export * from './types';

import { TourConfig } from './types';

// Import individual tour configs
import { pdfEditorTour } from './pdf-editor.tour';
import { wordEditorTour } from './word-editor.tour';

/**
 * Registry of all available tours
 * Add new tours here after creating their config files
 */
export const tourRegistry: Record<string, TourConfig> = {
  'pdf-editor': pdfEditorTour,
  'word-editor': wordEditorTour,
};

/**
 * Get a tour config by ID
 */
export const getTourById = (tourId: string): TourConfig | undefined => {
  return tourRegistry[tourId];
};

/**
 * Get all tours for a specific context/page
 */
export const getToursForContext = (context: string): TourConfig[] => {
  return Object.values(tourRegistry).filter(
    (tour) => tour.context === context || !tour.context
  );
};

/**
 * Register a new tour at runtime (useful for dynamic tours)
 */
export const registerTour = (tour: TourConfig): void => {
  tourRegistry[tour.id] = tour;
};
